import { render, staticRenderFns } from "./my-projects.vue?vue&type=template&id=4a58a52e&scoped=true"
import script from "./my-projects.vue?vue&type=script&lang=js"
export * from "./my-projects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58a52e",
  null
  
)

export default component.exports